import type { TFunction } from "i18next";
import type { PromptServiceDefaultModel } from "@nexus/contracts";

/** Human-readable service-default line for table cells and editor hints. */
export function formatPromptServiceDefaultLabel(
  t: TFunction,
  defaultModel: PromptServiceDefaultModel | null | undefined,
): string {
  if (!defaultModel) {
    return t("prompts.table.serviceDefault", "Service default");
  }
  if (defaultModel.resolved) {
    return t("prompts.table.serviceDefaultResolved", "Service default · {{model}}", {
      model: defaultModel.resolved,
    });
  }
  if (!defaultModel.configKey) {
    return t("prompts.table.serviceDefault", "Service default");
  }
  return t("prompts.table.serviceDefaultKey", "Service default · {{key}}", {
    key: defaultModel.configKey,
  });
}

/** Editor hint under the picker when null model is selected. */
export function formatPromptServiceDefaultHint(
  t: TFunction,
  defaultModel: PromptServiceDefaultModel | null | undefined,
): string {
  if (!defaultModel) {
    return t(
      "prompts.editor.model.serviceDefaultHint",
      "Each call site keeps its configured model",
    );
  }
  if (defaultModel.resolved && !defaultModel.configKey) {
    return t(
      "prompts.editor.model.serviceDefaultFixedHint",
      "Runs {{model}} (fixed package default) when unset here",
      { model: defaultModel.resolved },
    );
  }
  if (defaultModel.resolved && defaultModel.configKey) {
    return t(
      "prompts.editor.model.serviceDefaultResolvedHint",
      "Runs {{model}} via {{key}} when unset here",
      { model: defaultModel.resolved, key: defaultModel.configKey },
    );
  }
  if (!defaultModel.configKey) {
    return t(
      "prompts.editor.model.serviceDefaultHint",
      "Each call site keeps its configured model",
    );
  }
  return t(
    "prompts.editor.model.serviceDefaultKeyHint",
    "Falls back to env {{key}} when unset here",
    { key: defaultModel.configKey },
  );
}
